<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Checklist Dashboard</div>
    </div>

    <mat-divider class="divider-top"></mat-divider>

    <div class="subtitle-row">
      <div class="left-section">
        <div class="total-sites">{{ startIndex }} - {{ endIndex }} of {{ totalItems }} Total Carbon Sites</div>
        <div class="pagination-select table-container">
          <mat-form-field>
            <mat-select (selectionChange)="goToPage(1)" [(value)]="paginationTotal" class="select-filter">
              <mat-option [value]="20">20 Per page</mat-option>
              <mat-option [value]="40">40 Per page</mat-option>
              <mat-option [value]="100">100 Per page</mat-option>
              <mat-option [value]="99999">Show All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <div class="terminated-filter">
            <mat-checkbox
              #assignedToMe
              (change)="applyAssignedToMeFilter($event, 'assigned_to_me')"
              value="true"
              [checked]="filterValues.assigned_to_me"
              class="show-terminated">
              Assigned to Me
            </mat-checkbox>
          </div>
        </div>
        <div
          (click)="clearFilters()"
          [className]="
            this.getBaseQueryString() === this.getFullQueryString() ? 'clear-filter disabled-filter' : 'clear-filter'
          ">
          Clear All Filters
        </div>
      </div>
      <div class="right-section">
        <div class="select-instruction">Select at least one row to enable bulk controls</div>
        <mat-form-field class="field bulk-actions">
          <mat-select (selectionChange)="bulkAction($event)" placeholder="Bulk Actions">
            <mat-option [disabled]="!enableBulkSiteStateChangeButton" value="status">Change Site Status</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table [dataSource]="dataSource" mat-table aria-describedby="List of Sites" class="fc-table no-header">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th scope="col" *matHeaderCellDef mat-header-cell class="checkbox-cell">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [aria-label]="checkboxLabel()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
        </th>
        <td (click)="$event.stopPropagation()" *matCellDef="let row" class="checkbox-cell" mat-cell>
          <mat-checkbox
            (change)="$event ? selection.toggle(row) : null"
            (click)="$event.stopPropagation()"
            [aria-label]="checkboxLabel(row)"
            [checked]="selection.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="submittedDate">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-small">
          <div (click)="toggleMultiSort('submitted_date')" class="header-with-sort">
            <span>Submitted Date</span>
            <span [class]="sortBy['submitted_date']" class="sort-icon-container">
              <fc-sort-icon [column]="'submitted_date'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell class="column-small">
          {{ row.submittedDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-large">
          <div (click)="toggleMultiSort('status')" class="header-with-sort">
            <span>Status</span>
            <span [class]="sortBy['status']" class="sort-icon-container">
              <fc-sort-icon [column]="'status'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
          <mat-form-field>
            <mat-select
              (closed)="applyStatusFilter()"
              [(value)]="filterValues.status"
              class="select-filter"
              multiple
              panelClass="status-panel"
              placeholder="Filter">
              <mat-option *ngFor="let status of sortStatusArray" [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="column-large">
          {{ row.status }}
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-x-small">
          <div (click)="toggleMultiSort('id')" class="header-with-sort">
            <span>ID #</span>
            <span [class]="sortBy['id']" class="sort-icon-container">
              <fc-sort-icon [column]="'id'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
          <mat-form-field>
            <input
              #filterId
              (keyup)="applyFilter($event, 'id')"
              [(value)]="filterValues.id"
              class="filterInput"
              matInput />
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="column-x-small">
          {{ row.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-large">
          <div (click)="toggleMultiSort('name')" class="header-with-sort">
            <span>Site Name</span>
            <span [class]="sortBy['name']" class="sort-icon-container">
              <fc-sort-icon [column]="'name'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
          <mat-form-field>
            <input
              #filterName
              (keyup)="applyFilter($event, 'name')"
              [(value)]="filterValues.name"
              matInput
              placeholder="Filter" />
          </mat-form-field>
        </th>
        <td *matCellDef="let row" class="site-name column-large" mat-cell>
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="needsReview">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-x-small">
          <div>Note</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="applyNeedsReviewFilter($event, 'needs_review')"
              [(value)]="filterValues.needs_review"
              panelWidth=""
              class="select-filter">
              <mat-option [value]="">None</mat-option>
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="column-x-small">
          @if (isLimitedAdmin ? row.limitedAdminNeedsReview : row.needsReview) {
            <div class="icon">
              <fa-icon [icon]="['far', 'exclamation-triangle']" class="red size-18"></fa-icon>
            </div>
          }
        </td>
      </ng-container>

      <ng-container *ngFor="let reviewCheck of reviewChecks" [matColumnDef]="reviewCheck.name">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-x-small">
          <div>{{ reviewCheck.display }}</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="applyReviewCheckFilter($event, reviewCheck.check)"
              [(value)]="reviewCheckFilterValue[reviewCheck.check]"
              panelWidth=""
              class="select-filter">
              <mat-option [value]="">All</mat-option>
              <mat-option *ngFor="let option of possibleValues" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="column-x-small">
          <fa-icon
            *ngIf="getReviewCheck(row, reviewCheck.check) === 'No'"
            [icon]="['far', 'xmark']"
            matTooltip="No"
            class="red size-20"
            title="NO"></fa-icon>
          <fa-icon
            *ngIf="getReviewCheck(row, reviewCheck.check) === null"
            [icon]="['far', 'triangle-exclamation']"
            matTooltip="Not Completed"
            class="orange size-20"
            title="Not Complete"></fa-icon>
          <fa-icon
            *ngIf="getReviewCheck(row, reviewCheck.check) === 'Yes'"
            [icon]="['fas', 'check']"
            matTooltip="Yes"
            class="green size-20"
            title="YES"></fa-icon>
          <fa-icon
            *ngIf="getReviewCheck(row, reviewCheck.check) === 'Deferred'"
            [icon]="['far', 'circle-question']"
            matTooltip="Deferred"
            class="orange size-20"
            title="Deferred"></fa-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="assignedAdmin" *ngIf="!this.isLimitedAdmin">
        <th scope="col" *matHeaderCellDef mat-header-cell class="column-large">
          <div>Assigned Admin</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="getItemByAssignedAdminId($event, 'assigned_admin_id')"
              [(value)]="filterValues.assigned_admin_id"
              class="select-filter"
              placeholder="Filter">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let admin of admins" [value]="admin.id">
                {{ admin.getDisplayName() }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="column-large">
          {{ row.assignedAdmin ? row.assignedAdmin.getDisplayName() : '' }}
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr
        (click)="clickRow($event, row)"
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="row.isTooBig || row.isTooSmall ? 'alert' : null"
        mat-row></tr>
    </table>
  </div>

  <fc-table-pagination
    [totalPages]="totalPages"
    (goToPage)="goToPage($event)"
    [currentPage]="currentPage"
    [showPages]="showPages"></fc-table-pagination>
</div>
